'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var styled = _interopDefault(require('styled-components'));
var maplibreGl = require('maplibre-gl');
var useResizeObserver = _interopDefault(require('@react-hook/resize-observer'));
var MapMarker = require('./MapMarker.js');
var maplibreStyles = require('./maplibreStyles.js');
var graphql = require('./graphql.js');

var MapContainer = styled.div.withConfig({
  componentId: "sc-1bf30wg-0"
})(["", ""], maplibreStyles.default);
var ResizableMap = function ResizableMap(_ref) {
  var coordinates = _ref.coordinates,
    maptilerKey = _ref.maptilerKey,
    s = _ref.s;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    maplibre = _React$useState2[0],
    setMaplibre = _React$useState2[1];
  var mapContainer = React.useRef(null);
  var mapElement = React.useRef(null);
  var mapMarker = React.useRef(null);
  var lng = coordinates.lng,
    lat = coordinates.lat;

  // Resize the map whenever the mapElement itself has a different size.
  // This is useful because, in addition to the window resizing, many other
  // events in the page can cause mapElement to resize and we need the map
  // to respond accordingly
  useResizeObserver(mapContainer, function () {
    if (maplibre) maplibre.resize();
  });
  React.useEffect(function () {
    if (!mapElement.current) return;
    setMaplibre(new maplibreGl.Map({
      container: mapElement.current,
      style: "https://api.maptiler.com/maps/streets/style.json?key=".concat(maptilerKey),
      center: [lng, lat],
      zoom: 15,
      trackResize: false // trackResize only resizes on window resize. This case is covered by useResizeObserver
    }));
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [maptilerKey]);
  React.useEffect(function () {
    if (!(maplibre && mapMarker.current)) return;
    new maplibreGl.Marker(mapMarker.current).setLngLat([lng, lat]).addTo(maplibre);
  }, [maplibre, lng, lat]);
  return /*#__PURE__*/React.createElement(MapContainer, {
    style: s,
    ref: mapContainer
  }, /*#__PURE__*/React.createElement("div", {
    ref: mapElement,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(MapMarker.default, {
    ref: mapMarker
  })));
};
ResizableMap.defaultProps = {
  s: {
    height: '20rem',
    width: '20rem'
  }
};
ResizableMap.propTypes = {
  maptilerKey: PropTypes.string.isRequired,
  coordinates: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }).isRequired,
  s: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired)
};

exports.maptilerQuery = graphql.default;
exports.default = ResizableMap;
